import React, { useEffect, useState } from 'react'
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined'
import QueryBuilderOutlinedIcon from '@material-ui/icons/QueryBuilderOutlined'
import './productList.css'
import LazyImage from '../../atoms/LazyImage'
import FavoriteCheckbox from '../../atoms/FavoriteCheckbox'
import PrimaryButton from '../../atoms/PrimaryButton'
import Timer from '../../../Utils/Timer'
import numeral from 'numeral'
import { useTranslation } from 'react-i18next'
const ProductList = (props) => {
    const [expandedId, setExpandedId] = useState(null)
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const toggleDetails = (id) => {
        setExpandedId(expandedId === id ? null : id)
    }
    const { t } = useTranslation()
    const { data } = props
    const extra_fields = JSON.parse(data.extra_fields)[3]
    return (
        <div className="car-listing-container myListing ending-list-view">
            <div className="car-card">
                <div className="car-header">
                    <div className="position-relative">
                        {/* <img src={car.image.img1} alt={car.title} className="car-image" /> */}
                        <LazyImage
                            src={`${process.env.REACT_APP_PRODUCT_URL}/${data.file_name}`}
                            // src="../../../assets/images/upcoming/compressed/2020-Chevrolet-Corvette-Stingray-Coupe-2LT.webp"
                            alt={data.protitle}
                            className="car-image"
                            onClick={props.onClick}
                            style={{ cursor: 'pointer' }}
                        />
                        <button className="status-button" style={{ background: 'none' }}>
                            {parseInt(data.rprice) === 0 ? (
                                <span className="noRsrvTxt">No Reserve</span>
                            ) : parseInt(data.rprice) <= data.wprice ? (
                                <span className="yesRsrvTxt">{t('reserve_met')}</span>
                            ) : (
                                ''
                            )}
                        </button>
                        <div className="cmr">
                            <FavoriteCheckbox
                                checked={data.watch}
                                productId={data.id}
                                onChecked={props.handleChecked}
                            />
                        </div>
                    </div>
                    <div className="car-info">
                        <h2 className="car-title" onClick={props.onClick}>
                            {data.tags} {data.title} &nbsp;{data.category_id}
                        </h2>
                        <span className="car-meta">
                            {t('mileage')} : <span> {data.custom_field_4} Km </span>
                        </span>
                        <p className="car-description">
                            <span style={{ fontWeight: '600' }}> {t('description')}:</span>{' '}
                            {[
                                extra_fields?.makeType && extra_fields?.tradeName
                                    ? extra_fields?.tradeName + ' ' + extra_fields?.tradeName
                                    : '',
                                `${extra_fields?.regNum}`.toUpperCase(),
                                extra_fields?.yearModel,
                                extra_fields?.fuelType,
                                extra_fields?.enginePower
                                    ? isNaN(extra_fields?.enginePower)
                                        ? 0
                                        : `${Math.round(extra_fields?.enginePower * 1.36)} hp`
                                    : 0,
                                extra_fields?.rackvidd != 0 && extra_fields?.rackvidd != 'NA'
                                    ? `${extra_fields?.rackvidd} KM`
                                    : 0,
                                extra_fields?.driveTrain,
                                extra_fields?.transmission,
                                data?.custom_field_4
                                    ? `${data?.custom_field_4} ${t('mileage')}`
                                    : '',
                            ]
                                .filter(Boolean) // filters out empty strings, null, undefined
                                .join(', ')}
                        </p>
                    </div>
                    <div style={{ padding: '15px' }}>
                        <Timer
                            date_added={data.date_added}
                            date_closed={data.date_closed}
                            withText={1}
                        />
                        <div className="end-time">
                            {/* <span>Ends on</span>: 03 Jan 2025 14h:30 */}
                            <span className="bid-title">{t('start_bid')}</span>
                            <span
                                className="product-price-dynamic"
                                style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                                &nbsp; $
                                {parseInt(data.wprice).toLocaleString().length > 5
                                    ? numeral(parseInt(data.wprice).toLocaleString()).format('0 a')
                                    : `${parseInt(data.wprice).toLocaleString()}`}
                            </span>
                        </div>
                        <PrimaryButton onClick={props.onClick} customClassName="bidNowBtn">
                            {t('bid_now')}
                        </PrimaryButton>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProductList
